import React from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <nav className="navbar navbar-expand-md navbar-dark sticky-top" id="navbar">
      <div className="container-fluid">
        <Link className="navbar-brand fw-bold"  to="/">JIMMY BOSTROEM</Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle Navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="nav navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/?scrollTo=home">HOME</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/?scrollTo=projects">PROJECTS</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/?scrollTo=contact">CONTACT</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
